import { SvgIcon, SvgIconProps } from "@mui/material";

interface IconProps extends SvgIconProps {}

const InvalidateIcon = ({ hovered = false, ...props }): IconProps => {
  return (
    <SvgIcon style={{ fill: "none" }} {...props}>
      {hovered ? (
        <>
          <path
            d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z"
            fill="#F1ADAC"
            fill-opacity="0.8"
          />
          <path
            d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.8645 5.86499L13.8645 13.865"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.8645 5.86499L5.8645 13.865"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      ) : (
        <>
          <path
            d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z"
            fill="#F1ADAC"
          />
          <path
            d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z"
            stroke="#292929"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5.8645 5.86499L13.8645 13.865"
            stroke="#292929"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.8645 5.86499L5.8645 13.865"
            stroke="#292929"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default InvalidateIcon;
